/* src/app/components/allergens-info-modal/allergens-info-modal.component.scss */
.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.black-color {
  color: #1A1A18;
}
.header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding: 10px 0px;
  background: transparent;
  height: calc(100% - 80px);
  padding: 30px 20px;
  text-transform: uppercase;
}
.header .icon_wrapper ion-icon {
  height: 10px;
  width: 10px;
  rotate: 180deg;
  transition: rotate 0.5s;
  margin-left: 10px;
}
.header .icon_wrapper ion-icon.isOpen {
  rotate: 0deg;
}
.title {
  cursor: pointer;
  position: relative;
  margin: 0;
  text-transform: uppercase;
  font-size: 16px;
  line-height: 16px;
  text-align: left;
  color: #fff;
}
.name {
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.01em;
  color: #fff;
  text-align: left;
  text-transform: uppercase;
  padding: 15px 0px;
}
p {
  padding: 15px 0px;
  text-align: left;
  font-family: AppFont, sans-serif;
  font-size: 11.5px;
  line-height: 20px;
  letter-spacing: 0.01em;
  text-transform: uppercase;
  color: #fff;
}
div {
  position: relative;
  transition: max-height linear 0.3s;
}
.active {
  max-height: fit-content;
  overflow: auto;
  width: 100%;
  padding-top: 10px;
}
.inactive {
  max-height: 0;
  overflow: hidden;
}
.nutrition-name {
  font-size: 10px;
  text-align: left;
  color: #fff;
  padding-left: 20px;
}
.nutrition-value {
  text-align: right;
  color: #fff;
  text-transform: uppercase;
  font-size: 10px;
  padding-right: 20px;
}
.border-top {
  border-top: 1px solid var(--color-black);
}
.allergens_title {
  font-family: AppFont, sans-serif;
  font-size: 16px;
  color: #fff;
  text-transform: uppercase;
}
ul {
  margin: 0px;
  padding: 0px 30px;
}
ul li {
  font-size: 10px;
  text-align: left;
  color: var(--ion-color-black) !important;
  text-transform: uppercase;
  padding: 6px 0px;
}
.padding-top {
  padding-top: 15px;
}
.button {
  width: 100%;
  padding: 20px;
  border-top: 1px solid var(--color-black);
  margin-top: 20px;
}
.button .close {
  background: #ebdfda;
  text-align: center;
  border-radius: 26px;
  cursor: pointer;
}
.button .close:hover {
  background: #f2dbd9;
}
.button .close p {
  text-align: center;
  font-size: 16px;
  padding: 10px;
  color: #fff !important;
  text-transform: uppercase;
}
.cross-icon {
  position: absolute;
  right: 12px;
  z-index: 99;
}
/*# sourceMappingURL=allergens-info-modal.component.css.map */
